import { Component } from '@angular/core';

@Component({
  selector: 'app-mobile-background',
  templateUrl: './mobile-background.component.html',
  styleUrls: ['./mobile-background.component.scss']
})
export class MobileBackgroundComponent {

}
